module.exports = __webpack_public_path__ + "img/10.10927612.png";